export default "__VITE_ASSET__BmtvOT19__"